export default "__VITE_ASSET__DE61utGE__"